import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

/**
 * Price Change Acknowledge Controller (CONEK-4436 US-007)
 *
 * Posts an acknowledgement for the given import and applies the returned Turbo
 * Stream to remove the banner group.
 *
 * We request the stream as text and apply it explicitly via
 * Turbo.renderStreamMessage instead of relying on @rails/request.js to
 * auto-render it: with Turbo Drive active but no Turbo-initiated navigation,
 * the fetch-response stream is not reliably applied, leaving the button
 * disabled and the banner on screen. This mirrors the pattern used elsewhere
 * (e.g. roi/tco_calculator_controller).
 */
export default class extends Controller {
  static values = { url: String }

  async acknowledge(event) {
    const importLogId = event.params.importLogId
    if (!importLogId) return

    const button = event.currentTarget
    button.disabled = true

    try {
      // Send as form data (NOT application/json): a JSON content-type trips
      // Rodauth's json_request? guard, which treats the POST as an
      // unauthenticated API call and redirects to /login — the request never
      // reaches the controller and the banner stays. FormData keeps the
      // session cookie auth path. (See memory: no_directupload_rodauth_json_401)
      const body = new FormData()
      body.append("import_log_id", importLogId)

      const response = await post(this.urlValue, {
        body,
        responseKind: "turbo-stream",
      })

      if (response.ok) {
        const html = await response.text
        if (html) window.Turbo.renderStreamMessage(html)
      } else {
        button.disabled = false
      }
    } catch {
      // Re-enable so the user can retry instead of being stuck on a dead button.
      button.disabled = false
    }
  }
}
